// Action Types
export const UPDATE_DOCUMENT_UPLOAD_STATE = "UPDATE_DOCUMENT_UPLOAD_STATE";

// Action Creator
export const updateDocumentUploadState = (newState) => ({
    type: UPDATE_DOCUMENT_UPLOAD_STATE,
    newState,
});